import { Image } from "@tiptap/extension-image";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ImageWithDownload from "./ImageWithDownload";

export const CustomImage = Image.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ImageWithDownload);
  },
});
